export const onlineGenerationFormat = 1
export const csvReportFormat = 7
